// extracted by mini-css-extract-plugin
export default {"container":"ProductQuestions_container__RjxFF","separator":"ProductQuestions_separator__iI7bP","linkBtn":"ProductQuestions_linkBtn__+zwS4"};